import Vue from 'vue';
import "babel-polyfill";
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    lang: 'ZH_CN',
    token: '',
    name: '',
    avatar: '',
  },
  mutations: {
    setLang (state, val){
      state.lang = val
    },
    setToken (state, val){
      state.token = 'JWT ' + val
      // console.log('33333333 ' + state.token)
      localStorage.setItem("token",'JWT ' + val);
    },
    setName (state, val){
      state.name = val
      localStorage.setItem("name", val);
    },
    setAvatar (state, val){
      state.avatar = val
      localStorage.setItem("avatar", val);
    },
    logout () {
      // Cookies.remove('user')
      localStorage.clear()
    }
  },
  actions: {

  },
  modules: {

  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js